'use strict';

exports.Address4 = require('./lib/ipv4.js');
exports.Address6 = require('./lib/ipv6.js');

exports.v6 = {
  helpers: require('./lib/v6/helpers.js')
};
